import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import CardHeadlineFont from '../../Theme/Fonts/CardHeadline'
import { BasicCardHeadlineProps } from '..'
import { WebHeadlineType } from '../../Theme/Fonts/BasicText'
import Image from '../../BaseComponents/Image'
import PlayerImage from '../../BaseComponents/Image/Player'
import LinkProps from '../../Link/LinkProps'

type Props = WebHeadlineType & {
    /**decide between PlayerImage circled and default image with square shape */
    imageType?: 'DEFAULT' | 'PLAYER'
    /**to display an image on the left from the headline */
    imageUrl?: string
} & LinkProps &
    BasicCardHeadlineProps

const BasicCardHeadline: FunctionComponent<Props> = ({
    text,
    imageUrl,
    imageType = 'DEFAULT',
    webHeadlineType,
    textColor,
}): ReactElement => {
    return (
        <>
            {imageUrl ? (
                <Grid noExpand centerVertical alignLeft marginRight={3}>
                    {imageType === 'DEFAULT' ? (
                        <Grid noExpand center backgroundColor="pearl-4" width={26} height={26}>
                            <Image
                                size="L"
                                width={24}
                                height={24}
                                imageUrl={imageUrl}
                                aspectRatio="1:1"
                            />
                        </Grid>
                    ) : (
                        <PlayerImage size="L" width={22} imageUrl={imageUrl} />
                    )}
                </Grid>
            ) : null}
            <Grid minWidth={0} width="100%">
                <CardHeadlineFont
                    numberOfLines={1}
                    webHeadlineType={webHeadlineType}
                    color={textColor}
                >
                    {text}
                </CardHeadlineFont>
            </Grid>
        </>
    )
}

export default memo(BasicCardHeadline)
